import { makeValidateSync } from '@ocx-app/lib/form/utils';
import { intl } from '@ocx-app/lib/translation/TranslationProvider';
import { validationMessages } from '@ocx-app/modules/localization/validationMessages';
import { object, string } from 'zod';

const emailErrorMessage = intl.formatMessage(validationMessages['validation:form:email:required']);

const schema = object({
  email: string({ message: emailErrorMessage }).email(emailErrorMessage),
}).required();

export const completeEmailFormValidationSchema = makeValidateSync(schema);
